export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 md:gap-10">
            <div className="col-span-2 lg:col-span-2">
              <h3 className="text-xl font-heading font-bold text-foreground-50 mb-4">成全影院</h3>
              <p className="text-sm text-foreground-500 leading-relaxed max-w-[360px]">
                成全影院提供最新电影新剧上线抢先看，热门综艺更新快，电影电视剧全集免费在线高清不卡顿。每日同步热播资源，打造极致观影体验。
              </p>
              <div className="flex items-center gap-4 mt-6">
                <a href="#hero" className="w-9 h-9 rounded-lg bg-background-200 flex items-center justify-center text-foreground-400 hover:text-primary-400 transition-colors duration-200 no-underline">
                  <i className="ri-wechat-line text-base"></i>
                </a>
                <a href="#hero" className="w-9 h-9 rounded-lg bg-background-200 flex items-center justify-center text-foreground-400 hover:text-primary-400 transition-colors duration-200 no-underline">
                  <i className="ri-weibo-line text-base"></i>
                </a>
                <a href="#hero" className="w-9 h-9 rounded-lg bg-background-200 flex items-center justify-center text-foreground-400 hover:text-primary-400 transition-colors duration-200 no-underline">
                  <i className="ri-bilibili-line text-base"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-200 mb-4">快速导航</h4>
              <div className="flex flex-col gap-3">
                <a href="#index" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 no-underline whitespace-nowrap">专题合集</a>
                <a href="#ranking" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 no-underline whitespace-nowrap">热度榜单</a>
                <a href="#cards" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 no-underline whitespace-nowrap">精选内容</a>
                <a href="#faq" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-200 no-underline whitespace-nowrap">常见问题</a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-200 mb-4">内容分类</h4>
              <div className="flex flex-col gap-3">
                <span className="text-sm text-foreground-500 whitespace-nowrap">最新电影</span>
                <span className="text-sm text-foreground-500 whitespace-nowrap">新剧上线</span>
                <span className="text-sm text-foreground-500 whitespace-nowrap">热门综艺</span>
                <span className="text-sm text-foreground-500 whitespace-nowrap">动漫番剧</span>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-200 mb-4">合作伙伴</h4>
              <p className="text-sm text-foreground-600 whitespace-nowrap">虚位以待</p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-600 whitespace-nowrap">
              &copy; {new Date().getFullYear()} 成全影院 · 保留所有权利
            </p>
            <div className="flex items-center gap-6">
              <span className="text-xs text-foreground-600 whitespace-nowrap">服务条款</span>
              <span className="text-xs text-foreground-600 whitespace-nowrap">隐私政策</span>
              <span className="text-xs text-foreground-600 whitespace-nowrap">免责声明</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}